import { render, staticRenderFns } from "./MarketsSwitcher.vue?vue&type=template&id=5a5a07d3&scoped=true"
import script from "./MarketsSwitcher.vue?vue&type=script&lang=js"
export * from "./MarketsSwitcher.vue?vue&type=script&lang=js"
import style0 from "./MarketsSwitcher.vue?vue&type=style&index=0&id=5a5a07d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a5a07d3",
  null
  
)

export default component.exports